import { Injectable, inject } from '@angular/core';

import { IMutableContext, UnleashClient } from 'unleash-proxy-client';

import { UNLEASH_CONFIGURATION, UnleashConfiguration } from '../interface/feature-flags.interface';
import { TogglesFacade } from '../state/toggles/toggles.facade';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private facade = inject(TogglesFacade);

  unleash: UnleashClient;

  constructor() {
    const config = inject<UnleashConfiguration>(UNLEASH_CONFIGURATION);

    this.unleash = new UnleashClient({
      url: config.url,
      clientKey: config.clientKey,
      appName: config.appName,
      environment: config.environment,
    });

    const update = () => {
      let state = {};

      this.toggles().forEach(
        (toggle: {
          name: string;
          enabled: boolean;
          variant: {
            name: string;
            enabled: boolean;
            payload?: {
              type: string;
              value: string;
            };
          };
          impressionData: boolean;
        }) => {
          state = {
            ...state,
            [toggle.name]: toggle.enabled,
          };
        }
      );

      this.facade.update(state);
    };

    this.unleash.on('ready', update);
    this.unleash.on('update', update);
  }

  start(): void {
    this.unleash.start();
  }

  stop(): void {
    this.unleash.stop();
  }

  updateContext(contextObj: IMutableContext): void {
    this.unleash.updateContext(contextObj);
  }

  isEnabled(feature: string): boolean {
    return this.unleash.isEnabled(feature);
  }

  toggles() {
    return this.unleash.getAllToggles();
  }
}
